<mat-card fxLayout="row" fxLayoutGap="10px" class="mat-elevation-z8">
    <div>
        <mat-card-header>
            <div mat-card-avatar class="example-header-image"></div>
            <mat-card-title>Asset Label</mat-card-title>
            <mat-card-subtitle>Printing</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <p>
                Enter the values and click print.
            </p>
            <mat-form-field class="example-full-width">
                <mat-label i18n="@@id">ID</mat-label>
                <input matInput type="number" placeholder="e.g. 12345" [(ngModel)]="label.id">
            </mat-form-field>
            <mat-form-field class="example-full-width">
                <mat-label i18n="@@place">Place</mat-label>
                <input matInput type="text" placeholder="e.g. KA" [(ngModel)]="label.place">
            </mat-form-field>
            <mat-form-field class="example-full-width">
                <mat-label i18n="@@info">Info</mat-label>
                <input matInput type="text" placeholder="e.g. Length: 5m" [(ngModel)]="label.info">
            </mat-form-field>
            <mat-form-field class="example-full-width">
                <mat-label>Aquisition Date</mat-label>
                <input matInput [matDatepicker]="dp" [formControl]="date">
                <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                <!-- <mat-datepicker #dp startView="multi-year" (yearSelected)="chosenYearHandler($event)"
                    (monthSelected)="chosenMonthHandler($event, dp)" panelClass="example-month-picker">
                </mat-datepicker> -->
                <mat-datepicker #dp panelClass="example-month-picker">
                </mat-datepicker>
            </mat-form-field>

        </mat-card-content>
        <mat-card-actions>
            <button mat-button (click)="printLabel();">Print</button>
        </mat-card-actions>
    </div>
    <app-label-preview [label]="label" class="label-preview"></app-label-preview>
</mat-card>